export default __webpack_public_path__ + "static/media/transfer-international.f3cb2c74.png";